const aAvatarEdition = {
  aAvatarEdition: {
    changeAvatar: 'cambiar avatar',
    changetLogo: 'seleccionar logo'
  }
}

export default aAvatarEdition
